
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/wixData/components/videoTooltip/videoTooltip.scss.css.virtualfile';
        module.exports = {"infoIconImageContainer":"_infoIconImageContainer_3fri5_7","infoIconImage":"_infoIconImage_3fri5_7","playVideoIcon":"_playVideoIcon_3fri5_17"};